__turbopack_context__.v({
  "checkGroup": "Theme-module__R6bjbq__checkGroup",
  "colorField": "Theme-module__R6bjbq__colorField",
  "headerFrame": "Theme-module__R6bjbq__headerFrame",
  "headerScaler": "Theme-module__R6bjbq__headerScaler",
  "previewButton": "Theme-module__R6bjbq__previewButton",
  "styleGrid": "Theme-module__R6bjbq__styleGrid",
  "styleLabel": "Theme-module__R6bjbq__styleLabel",
  "styleOption": "Theme-module__R6bjbq__styleOption",
  "styleOptionSelected": "Theme-module__R6bjbq__styleOptionSelected",
  "styleScaler": "Theme-module__R6bjbq__styleScaler",
});
